import { $axios } from '@/modules/http/axios'
import jwtDecode from 'jwt-decode'

const permissionModule = {
  namespaced: true,

  state: () => ({
    permissions: []
  }),

  getters: {
    getPermissions (state) {
      return state.permissions
    }
  },

  mutations: {
    setPermissions (state, permissions) {
      state.permissions = permissions
    }
  },

  actions: {
    async fetchPermissions ({ commit, state }) {
      const decodedJwt = jwtDecode(localStorage.getItem('accessToken'))
      const userId = decodedJwt['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier']

      const permissions = (await $axios.get(`User/${userId}`)).data.permission
      commit('setPermissions', permissions)
    }
  }
}

export default permissionModule
